import { HelmetProvider } from 'react-helmet-async';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ScrollToHash from './components/ScrollToHash';
import Contact from './pages/Contact';
import Home from './pages/Home';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToHash />
        <div className="App min-h-screen flex flex-col bg-surface-100">
          <Navbar />
          <main className="flex-grow pt-16 lg:pt-[4.25rem]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/support"
                element={<Navigate to="/contact" replace />}
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
